<form role="form" #authenticateForm="ngForm" novalidate>
    <div class="input-group">
        <span class="input-group-addon">
            <i class="fa fa-envelope"></i>
        </span>
        <input class="form-control" type="text" placeholder="Email address"
           name="email" [(ngModel)]="tokenObject.email" [pattern]="MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL" required>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <button id="loginButton" type="submit" class="btn btn-success col-xs-12" (click)="authenticateToken()">Authenticate</button>
        </div>
    </div>
</form>
